<template>
  <div class="mainTainFundIndex">
    <van-image :src="logo" style="width: 100vw;"/>
    <div :key="el.value" :class="el.value" v-for="el in parts">
      <p class="block-title" v-text="el.label" :style="el.style"></p>
      <van-grid :border="false" :column-num="4" class="itemWire">
        <van-grid-item
            v-for="detail in el.housePickerColumns"
            :key="detail.value" @click="openSub(detail)">
          <template v-if="detail.value.indexOf('miniProgram-') !== -1">
            <van-image class="publicImgCss" :src="detail.image"/>
            <p class="van-card__desc van-ellipsis" v-text="detail.label"/>
            <wx-open-launch-weapp
                id="launch-btn"
                :appid="detail.value === 'miniProgram-zxbj' ? 'wx3c2a5a21dadef252' : detail.value === 'miniProgram-dygh' ? 'wx795f1b8c6681daf4' : 'wx91415a944dcd6de0'"
                :username="detail.value === 'miniProgram-zxbj' ? 'gh_66346a7d9e6e' : detail.value === 'miniProgram-dygh' ? 'gh_6e43d7aa68dd' : 'gh_95f5c2eb627d'"
                v-if="(detail.value === 'miniProgram-zxbj'&&auth) || detail.value === 'miniProgram-wybj' || detail.value === 'miniProgram-dygh'"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 999"
                :path="detail.value === 'miniProgram-zxbj' ? `pages/voteBusiness/vote/vote?wxId=${wxId}&token=${token}&cityCode=150400` : detail.value === 'miniProgram-dygh' ? 'pages/login' : `pages/login/index?cityCode=150400`"
            >
              <script type="text/wxtag-template">
                <style>
                  .box_a {
                    position: absolute;
                    top: 0;
                    width: 100%;
                    height: 100%;
                  }
                </style>
                <div class="box_a"></div>
              </script>
            </wx-open-launch-weapp>
          </template>
          <template v-else>
            <van-image class="publicImgCss" :src="detail.image"/>
            <p class="van-card__desc van-ellipsis" v-text="detail.label"/>
          </template>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="authentication" v-show="!auth" @click="startRegister">
      <van-image :src="noAuth" style="width: 40px;"/>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import {queryNoticeInfo, jsApiSignature} from "@/api/wx";
import {Toast} from "vant";

export default {
  name: 'MaintainFund',
  components: {},
  data() {
    return {
      logo: require('@/assets/logo.png'),
      noAuth: require('@/assets/noauth.png'),
      auth: false,
      wxId: '',
      token: '',
      parts: [
        // {
        //   label: '线上房交会',
        //   style: 'border-left: 6px solid #22acdd;',
        //   housePickerColumns: [
        //     {
        //       value: 'fyll',
        //       label: '2025年房交会',
        //       image: require('@/assets/fjhtb.jpg'),
        //       path: 'http://www.house-book.com.cn/mainAction/mainAction/city/%25E8%25B5%25A4%25E5%25B3%25B0%25E5%25B8%2582.html',
        //       checkAuth: false
        //     },
        //     {
        //       value: 'appxz',
        //       label: 'app下载',
        //       image: require('@/assets/zxbj-mini.png'),
        //       path: 'https://www.house-book.cn/AppUrl.html',
        //       checkAuth: false
        //     }
        //   ]
        // },
        {
          label: '信息公开',
          style: 'border-left: 6px solid #58A3FF;',
          housePickerColumns: [
            {
              value: 'TZGG',
              image: require('@/assets/tzgg.png'),
              label: '通知公告',
              path: '/public/articleList',
              checkAuth: false
            },
            {
              value: 'FWWD',
              label: '服务网点',
              image: require('@/assets/fwwd.png'),
              path: '/public/BranchList',
              checkAuth: false
            },
            {
              value: 'YWZN',
              label: '业务指南',
              image: require('@/assets/ywzn.png'),
              path: '/public/articleList',
              checkAuth: false
            }
            // ,
            // {
            //   value: 'APP',
            //   label: 'APP下载',
            //   image: require('@/assets/lyb.png'),
            //   path: 'https://fgj.chifeng.gov.cn/weixin/download/download.html',
            //   checkAuth: false
            // }
          ]
        },
        {
          label: '维修资金',
          style: 'border-left: 6px solid #22acdd;',
          housePickerColumns: [
            // 		{
            // 			value: 'bdfw',
            // 			label: '绑定房屋',
            // 			image: require('@/assets/bdfw.png'),
            // 			path: '/maintainFund/bindingHouse',
            // 			checkAuth: false
            // 		},
            {
              value: 'wdfw',
              label: '我的房屋',
              image: require('@/assets/htcx.png'),
              path: '/maintainFund/houseList',
              checkAuth: true
            },
            // 		{
            // 			value: 'zxbj',
            // 			label: '在线表决',
            // 			image: require('@/assets/zxbj.png'),
            // 			path: '/maintainFund/voteList',
            // 			checkAuth: false
            // 		},
            // 		{
            // 			value: 'zxjc',
            // 			label: '在线交存',
            // 			image: require('@/assets/sfbt.png'),
            // 			path: '/maintainFund/houseDeposit',
            // 			checkAuth: true
            // 		},
            {
              value: 'miniProgram-zxbj',
              label: '在线表决',
              image: require('@/assets/zxbj-mini.png'),
              path: '',
              checkAuth: true
            },
            {
              value: 'zxjc',
              label: '在线交存',
              image: require('@/assets/sfbt.png'),
              path: '/onlineDeposit',
              checkAuth: true
            },
            {
              value: 'pjhq',
              label: '票据获取',
              image: require('@/assets/bill.png'),
              path: '/maintainFund/billObtain/main',
              checkAuth: true
            },
            {
              value: '',
              label: '业主变更申请',
              image: require('@/assets/yzbg.png'),
              path: '/maintainFund/ownerChange',
              checkAuth: true
            },
            {
              value: 'miniProgram-wybj',
              label: '线下表决',
              image: require('@/assets/zxbj-mini.png'),
              path: '',
              checkAuth: false
            }
          ]
        },
        {
          label: '特色服务',
          style: 'border-left: 6px solid #22acdd;',
          housePickerColumns: [
            {
              value: '',
              label: '代办预约',
              image: require('@/assets/blyy.png'),
              path: '/maintainFund/businessProcessAppoint',
              checkAuth: true
            },
            {
              value: 'tssq',
              label: '补贴申请',
              image: require('@/assets/sfbt.png'),
              path: '/personal/subsidies/taxSubsidies',
              checkAuth: true
            },
            {
              value: 'wyfw',
              label: '物业服务',
              image: require('@/assets/wyfw.png'),
              checkAuth: false
            },
            {
              value: 'fjh',
              label: '销售统计',
              image: require('@/assets/fjh.png'),
              checkAuth: false
            },
            {
              value: 'miniProgram-dygh',
              label: '带押过户',
              image: require('@/assets/zxbj-mini.png'),
              path: '',
              checkAuth: false
            },
            {
              value: 'hthy',
              label: '合同核验',
              image: require('@/assets/bill.png'),
              checkAuth: false
            },
            {
              value: 'xkcx',
              label: '许可查询',
              image: require('@/assets/bill.png'),
              checkAuth: false
            }

          ]
        },
        {
          label: '个人中心',
          style: 'border-left: 6px solid #22acdd;',
          housePickerColumns: [
            {
              value: 'smrz',
              label: '实名认证',
              image: require('@/assets/smrz.png'),
              path: '/public/register?redirectUrl=maintainFund',
              checkAuth: true
            },
            {
              value: 'xxjl',
              label: '消息记录',
              image: require('@/assets/xxjl.png'),
              path: '/personal/notificationList',
              checkAuth: true
            },
            {
              value: 'htcx',
              label: '网签合同',
              image: require('@/assets/htcx.png'),
              path: '/houseResource/myHouse',
              checkAuth: true
            }
            ,
            {
              value: 'wqbacx',
              label: '网签备案查询',
              image: require('@/assets/bill.png'),
              path: '/houseResource/onlineSign',
              checkAuth: true
            }
          ]
        }
      ]
    }
  },
  mounted: function () {
    document.addEventListener('WeixinOpenTagsError', function (e) {
      console.log(e.detail.errMsg) // 无法使用开放标签的错误原因。需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
    })
    let url = window.location.href.split('#')[0]
    jsApiSignature({url: url}).then(res => {
      let resV = res.data;
      console.log('resv => ', resV)
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: resV.appId, // 必填，公众号的唯一标识
        timestamp: resV.timestamp.toString(), // 必填，生成签名的时间戳
        nonceStr: resV.nonceStr, // 必填，生成签名的随机串
        signature: resV.signature,// 必填，签名
        // 需要使用的JS接口列表
        jsApiList: ['scanQRCode', 'chooseImage', 'previewImage'],
        // 开放标签，跳转小程序时必填
        openTagList: ['wx-open-launch-weapp']
      });
      wx.ready(() => {
        this.wxId = this.$store.state.user.weixinId
        this.token = this.$store.getters.token
        console.log("this.$store.getters.token=", this.$store);
      })
    }).catch(() => {
      Toast.fail("签名接口异常，请联系管理员！")
    })

    // 从store取token，判断是否登录
    console.log("mounted函数执行了 this.$store.getters.token=" + this.$store.getters.token);
    console.log("this.$store" + this.$store);
    if (this.$store.getters.token) {
      this.auth = true;
      return;
    }
    queryNoticeInfo().then(response => {
      if(response.data&&response.data.length!==0){
        this.isShow = true
        this.gzsData = response.data[0]
        console.log('this.isShow',this.isShow)
        if(this.gzsData){
          this.djs(this.gzsData.displayTime)
        }
      }else{
        this.isShow = false
      }
      console.log('response',response)
    })
  },
  methods: {
    openSub(detail) {
      if ('miniProgram-zxbj' === detail.value && (this.auth)) {
        return
      }
      if ('miniProgram-wybj' === detail.value) {
        return;
      }
      if ('miniProgram-dygh' === detail.value) {
        return;
      }
      if ('APP' == detail.value) {
        window.location.href = 'https://fgj.chifeng.gov.cn/weixin/download/download.html'
      }
      if ('appxz' == detail.value) {
        window.location.href = 'https://www.house-book.cn/AppUrl.html'
      }
      if ('fyll' == detail.value) {
        window.location.href = 'http://www.house-book.com.cn/mainAction/mainAction/city/%25E8%25B5%25A4%25E5%25B3%25B0%25E5%25B8%2582.html'
      }
      if ('wyfw' == detail.value) {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx04a84cd13c1f71cb&redirect_uri=https://fgj.chifeng.gov.cn/zhwyh5/api/user/wxAuthorizeCallBack&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect'
      }
      if ('fjh' == detail.value) {
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx04a84cd13c1f71cb&redirect_uri=https://fgj.chifeng.gov.cn/zhwyh5/api/user/wxAuthorizeCallBack&response_type=code&scope=snsapi_userinfo&state=2#wechat_redirect'
      }
      if ('hthy' == detail.value) {
        window.location.href = 'http://1.30.162.45:8011/front/web/home/spfwqbzcx.jsp'
      }
      if ('xkcx' == detail.value) {
        window.location.href = 'http://1.30.162.45:8011/front/web/home/ysxsbagscx.jsp'
      }
      let path = detail.path;
      let label = detail.label;
      if (!this.auth && detail.checkAuth) {
        label = '实名认证'
        path = '/public/register?redirectUrl=maintainFund'
      }
      this.$router.push({
        path: path,
        query: {
          value: detail.value,
          label: encodeURIComponent(label)
        }
      })
    },
    startRegister() {
      this.$router.push({
        path: '/public/register?redirectUrl=maintainFund',
        query: {
          label: encodeURIComponent('实名认证')
        }
      })
    },
  }
}
</script>
<style scoped>
.mainTainFundIndex {
  text-align: center;
  background-color: white;
}

.itemWire {
  justify-content: left;
  border-bottom: 12px solid #F2F2F2;
}

.van-grid-item__content {
  padding: 0 !important;
}

.publicImgCss {
  width: 70%;
  margin: 0 auto;
  min-height: 50px;
  background-size: contain;
  background-repeat: no-repeat;
}

.block-title {
  margin: 35px 15px 10px;
  padding: 0 9px;
  line-height: 16px;
  font-weight: 600;
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: left;
  font-family: "Helvetica Neue", Helvetica, sans-serif;
}

.authentication {
  position: fixed;
  right: 5px;
  top: 80%;
  z-index: 100;
}
</style>
